import React, { useState } from "react";
import { useNavbarContext } from "../Navbar";
import styles from './Dropdown.module.scss';
import { NavList } from "../DesktopNavbar/DesktopList/NavList";
import classNames from "classnames";
import { NavItemProps } from "../../types";

interface DropdownProps {
  menu: NavItemProps[];
  isSelected?: boolean,
  isShowChild?: boolean,
  level: number,
  isDesktop?: boolean,
  isLoginMenu?: boolean,
}

export const Dropdown = (props: DropdownProps) => {
  const [hoveredChild, setHoveredChild] = useState<NavItemProps>(null);
  const { menu, isSelected = false, isDesktop = false, isLoginMenu = false, level } = props;

  var itemClass: string;

  const switchClass = ( level:number ) => {
    switch(level) {
      case 1:
        itemClass = 'primary_dropdown_menu';
        break;

      case 2:
        itemClass = 'secondary_dropdown_menu';
        break;

      default:
        itemClass = '';
    }

    return itemClass;
  }

  return (
    <ul className={classNames(
        styles[switchClass(level)],
        isSelected && styles['show'],
        isLoginMenu && styles['loginMenu']
      )}
      onMouseLeave = {() => {
        setHoveredChild(undefined)
      }}
    >
      {
        menu.map(item => (
          <NavList
            level = {level}
            key = {item.title}
            item = {item}
            isDesktop={isDesktop}
            onMouseOver = {()=>{
              setHoveredChild(item)
            }}
            onMouseLeave = {() => {
              setHoveredChild(undefined)
            }}
            isSelected = {hoveredChild && hoveredChild.title === item.title}
          />
        ))
      }
    </ul>
  )
}